import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NavComponent } from '../../core/component/Nav.Component';
import { UserService } from '../../core/service/user.service';
import { DataTransferObject } from '../../core/entities/DataTransferObject';
import { BaseComponent } from '../../core/component/Base.Component';
import { AuthGuard } from '../../core/helper/auth.guard';
import { AppConstants } from '../../app.constant';
import { LocalStorage } from '../../core/helper/localStorage';

@Component({
    selector: 'app-changepassword',
    templateUrl: './changepassword.component.html',
    styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent extends BaseComponent {


    myForm: FormGroup;
    utuser: any;

    constructor(
        private userservice: UserService,
        private auth: AuthGuard
    ) {
        super();
        this.initilizeForm();
        this.localStorage = AppConstants.injector.get(LocalStorage);
    }

    protected fb: FormBuilder = new FormBuilder();
    initilizeForm() {

        this.showToolbar(false);
        this.myForm = this.fb.group({
            'username': ['', [Validators.required]],
            'password': ['', [Validators.required]],
            'newpassword': ['', [Validators.required]],
            'confirmpassword': ['', [Validators.required]],
        });


    }

    async ngOnInit() {
        this.initilizeForm();
        this.setUserName();
    }

    async  ChangePassword() {
        var obj: DataTransferObject<any> = <DataTransferObject<any>>{};
        var user: any = {};
        var utuser = JSON.parse(this.localStorage.get('utuser'));
        const fullname = utuser.fullname
        const userid = utuser.userid
        const empid = utuser.empid

        const employeeid = utuser.employeeid
        const emailid = this.localStorage.get('emailid');
        user.userid = userid;
        user.empid = empid;
        user.fullname = fullname;
        user.employeeid = employeeid
        user.username = this.myForm.value.username;
        user.password = this.myForm.value.password;
        user.newpassword = this.myForm.value.newpassword;
        user.confirmpassword = this.myForm.value.confirmpassword;
        user.cellno = utuser.cellno;
        obj.Data = user;

        if ((user.username === null || user.username === "") || (user.password === null || user.password === "") || (user.newpassword === null || user.newpassword === "") || (user.confirmpassword === null || user.confirmpassword === "")) {

            if (user.username === null || user.username === "") {
                this.showErrors("User Name can not be empty");
            }

            if (user.password === null || user.password === "") {
                this.showErrors("Old Password can not be empty");
            }

            if (user.newpassword === null || user.newpassword === "") {
                this.showErrors("New Password can not be empty");
            }

            if (user.confirmpassword === null || user.confirmpassword === "") {
                this.showErrors("Confirm Password can not be empty");
            }
            return;
        }

        else {

            if (user.password == user.newpassword) {
                this.showErrors("Old Password and New Password can not be same");
                return;
            }

            if (user.newpassword != user.confirmpassword) {
                this.showErrors("New Password and Confirm Password not matched");
                return;
            }

            if (confirm('are you sure you want to change the password')) {
                const result = await this.userservice.put('ChangePassword', obj);
                if (result.IsSuccess) {

                    this.showSuccess("Successfully saved...");
                    // await this.clear();
                    this.setUserName();
                    this.localStorage.clear();
                    this.navigate("/login");

                }
                else {
                    this.showErrors(result.Errors);
                }
            }
        }
    }

    setUserName() {
        var username = this.localStorage.get('User');
        this.myForm.controls['username'].setValue(username);
    }


}



// WEBPACK FOOTER //
// ./src/app/login/changepassword/changepassword.component.ts